import type { FC } from 'react';
import { Alert } from 'react-daisyui';

type DnaErrorProps = {
  error: Error | null;
  className?: string;
};

const DnaError: FC<DnaErrorProps> = ({ error, className = '' }) => {
  if (!error) return null;

  return (
    <Alert className={`w-full font-sans text-sm ${className}`} status="error">
      {error.message}
    </Alert>
  );
};

export default DnaError;
